import { useLingui } from '@lingui/react/macro';

import { CompanySearch } from './CompanySearch/CompanySearch';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-680. Company register search step. Renders CompanySearch within the step
// layout.
export const CompanyScreen = () => {
  const { t } = useLingui();

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`What’s your company called?`}
      subHeading={t`We search the commercial register and fill in your details automatically.`}
      hideCta
    >
      <CompanySearch />
    </StepLayout>
  );
};
